"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.thankApe = void 0;
const ApeCoinStaking_json_1 = __importDefault(require("../abi/ApeCoinStaking.json"));
const ethers_1 = require("ethers");
const parseBlockTag_1 = require("../utils/parseBlockTag");
const balanceOfErc20_1 = require("./balanceOfErc20");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const utils_1 = require("ethers/lib/utils");
const thankApe = (params) => {
    return async () => {
        const { account, blockTag, provider } = params;
        // ThankApe check
        const url = `https://core.api.thrivecoin.com/v1/eligibility/thank-ape/voting/${account}`;
        const response = await fetch(url, {
            method: 'GET',
        });
        const { data, errors } = await response.json();
        const isEligible = data.eligible;
        if (!isEligible || errors)
            return 0;
        // Staked ApeCoin
        const stakedApeCoinContractAddress = '0x5954aB967Bc958940b7EB73ee84797Dc8a2AFbb9';
        const stakedApeCoin = new ethers_1.Contract(stakedApeCoinContractAddress, ApeCoinStaking_json_1.default, provider);
        const stakedApeCoinBalance = await stakedApeCoin.stakedTotal(account, {
            blockTag: (0, parseBlockTag_1.parseBlockTag)(blockTag),
        });
        const parsedStakedApeCoinBalance = new bignumber_js_1.default((0, utils_1.formatUnits)(stakedApeCoinBalance, 18).toString()).toNumber();
        // ApeCoin
        const apeCoinContractAddress = '0x4d224452801ACEd8B2F0aebE155379bb5D594381';
        const balanceOfErc20Args = {
            strategyName: 'balanceOfErc20',
            account: account,
            provider: provider,
            contract: apeCoinContractAddress,
            blockTag: blockTag,
            decimals: 18,
            multiplier: 1,
        };
        const apeBalance = await (0, balanceOfErc20_1.balanceOfErc20)(balanceOfErc20Args)();
        const totalApeCoin = apeBalance + parsedStakedApeCoinBalance;
        // Tiered voting
        if (totalApeCoin >= 100000)
            return 80;
        if (totalApeCoin >= 10000)
            return 40;
        if (totalApeCoin >= 1000)
            return 20;
        if (totalApeCoin >= 100)
            return 10;
        if (totalApeCoin >= 10)
            return 5;
        if (totalApeCoin >= 1)
            return 1;
        return 0;
    };
};
exports.thankApe = thankApe;
